import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, TerminalIcon, UsersIcon } from 'lucide-react';
const ConversionCTA = () => {
  return <section className="w-full bg-white py-16 sm:py-24 md:py-32 lg:py-48 relative overflow-hidden" id="pricing" data-id="element-296">
      <div className="container mx-auto px-4 sm:px-6 md:px-8" data-id="element-297">
        <div className="max-w-5xl mx-auto text-center" data-id="element-298">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 sm:mb-8 tracking-tight leading-tight" data-id="element-299">
            Turn your UI into an interface that completes work — safely.
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-lg sm:text-xl md:text-2xl text-gray-600 mb-10 sm:mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-300">
            FluidWeb gives AI a safe operating envelope — you define what it can
            do, when it can do it, and how it's verified.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center mb-10 sm:mb-12" data-id="element-301">
            <a href="https://cal.com/fluidn/30min" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 bg-orange-500 text-white px-8 sm:px-10 py-4 sm:py-5 rounded-full text-base sm:text-lg font-bold hover:bg-orange-600 transition-all shadow-lg shadow-orange-500/20 min-h-[44px]" data-id="element-302">
              Get a demo
              <ArrowRightIcon size={20} data-id="element-303" />
            </a>
            <a href="https://cal.com/fluidn/30min" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 bg-white text-gray-900 border border-gray-200 px-8 sm:px-10 py-4 sm:py-5 rounded-full text-base sm:text-lg font-bold hover:bg-gray-50 transition-all min-h-[44px]" data-id="element-304">
              <TerminalIcon size={20} data-id="element-305" />
              View docs
            </a>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="pt-6 sm:pt-8 border-t border-gray-100" data-id="element-306">
            <p className="text-sm text-gray-500 mb-3 sm:mb-4 px-4" data-id="element-307">
              Or join our community of builders shaping the future of agentic
              interfaces
            </p>
            <a href="/community" className="inline-flex items-center gap-2 text-orange-500 font-semibold hover:text-orange-600 transition-colors min-h-[44px]" data-id="element-308">
              <UsersIcon size={18} data-id="element-309" />
              Join FluidWeb Community
              <ArrowRightIcon size={16} data-id="element-310" />
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
};
export default ConversionCTA;